import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const TITULO_PADRAO = 'Magma Pro | Sistema para Marmorarias'
const DESCRICAO_PADRAO = 'Acesso ao sistema Magma Pro para marmorarias.'

// Única tela que deve aparecer no Google; as demais (login e telas internas) recebem noindex.
// O noindex é aplicado aqui, e não no index.html, porque o Google não renderiza a página
// quando encontra noindex no HTML original, e assim o cadastro nunca seria indexado.
const PAGINAS_INDEXAVEIS: Record<string, { titulo: string; descricao: string }> = {
  '/auth/signup': {
    titulo: 'Teste grátis por 30 dias | Magma Pro - Sistema para Marmorarias',
    descricao:
      'Cadastre sua marmoraria e use o Magma Pro grátis por 30 dias, sem cartão: orçamentos de pedras em m², pedidos, agenda de visitas e entregas, comissões e financeiro.',
  },
}

const definirMeta = (name: string, content: string) => {
  let meta = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = name
    document.head.appendChild(meta)
  }
  meta.content = content
}

export function PageMeta() {
  const { pathname } = useLocation()

  useEffect(() => {
    const pagina = PAGINAS_INDEXAVEIS[pathname.replace(/\/+$/, '')]
    document.title = pagina?.titulo ?? TITULO_PADRAO
    definirMeta('description', pagina?.descricao ?? DESCRICAO_PADRAO)
    definirMeta('robots', pagina ? 'index, follow' : 'noindex, nofollow')
  }, [pathname])

  return null
}
